module.exports = setImmediate



//////////////////
// WEBPACK FOOTER
// ./~/memdown/immediate.js
// module id = 1530
// module chunks = 0 1 2